import { render, staticRenderFns } from "./user_main.vue?vue&type=template&id=def6e276&lang=pug"
import script from "./user_main.vue?vue&type=script&lang=js"
export * from "./user_main.vue?vue&type=script&lang=js"
import style0 from "./user_main.vue?vue&type=style&index=0&id=def6e276&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports